import { render, staticRenderFns } from "./disbursementuploadform.vue?vue&type=template&id=30dd51c4&scoped=true&"
import script from "./disbursementuploadform.vue?vue&type=script&lang=js&"
export * from "./disbursementuploadform.vue?vue&type=script&lang=js&"
import style0 from "./disbursementuploadform.vue?vue&type=style&index=0&id=30dd51c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30dd51c4",
  null
  
)

export default component.exports